import React, { Component } from "react";
import BannerStack from "../components/BannerStack";
import BannerListItem from "../components/BannerListItem";

const BannerContext = React.createContext();

export class BannerProvider extends Component {
  state = {
    banners: []
  };

  count = 0;

  clone = arr => {
    return arr.slice(0);
  };

  add = bodyText => {
    this.setState(state => {
      const id = this.count++;
      const banners = this.clone(state.banners);
      banners.push({ bodyText, id });
      return { banners };
    });
  };

  render() {
    const context = {
      add: this.add
    };

    return (
      <BannerContext.Provider value={context}>
        <BannerStack>
          {this.state.banners.map(({ bodyText, id, ...rest }) => (
            <BannerListItem key={id}>{bodyText}</BannerListItem>
          ))}
        </BannerStack>

        {this.props.children}
      </BannerContext.Provider>
    );
  }
}

export default BannerContext;
